module.exports = __webpack_public_path__ + "img/119.ab525a11.jpg";